<template>
  <div class="container-fluid">
    <div class="card p-3">
      <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
        <div>
          <h5 class="mb-0 font-weight-bold">Download Postel</h5>
          <small class="fst-italic text-muted">*halaman ini digunakan untuk mengambil data dari web Kominfo</small>
        </div>
        <div class="d-flex align-items-center">
          <input class="form-control me-2" style="width: 200px;" type="date" v-model="tanggal" />
          <button class="btn mb-0 me-2" @click="getPostelPy(tanggal)">
            Run Py Parser
          </button>
          <button class="btn mb-0" @click="getPostel(tanggal)">
            Run Node Parser
          </button>
        </div>
      </div>  
      <div class="container mt-3">
        <div>
          <label for="log">Error Log:</label>
          <textarea
            name="log"
            id="log"
            cols="30"
            rows="20"
            class="form-control bg-dark text-white"
            disabled
            v-model="errorLog"
          ></textarea>
        </div>
      </div>
    </div>

<modal modalName="modalLoading" modalSize="modal-dialog-centered" :isFooter="false" :isHeader="false">
      <template #body>
        <div class="text-center p-3">
          <span>
            <h2 class="fs-5">Loading Process...</h2>
            <div class="my-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="margin: auto; background: #fff; display: block"
                width="150px"
                height="150px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle
                  cx="50"
                  cy="50"
                  r="32"
                  stroke-width="8"
                  stroke="#04697b"
                  stroke-dasharray="50.26548245743669 50.26548245743669"
                  fill="none"
                  stroke-linecap="round"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    repeatCount="indefinite"
                    dur="1s"
                    keyTimes="0;1"
                    values="0 50 50;360 50 50"
                  ></animateTransform>
                </circle>
              </svg>
            </div>
          </span>
        </div>
      </template>
    </modal>
  </div>
</template>

<script setup>
import Modal from "@/components/ModalComponent.vue";
import { ApiService } from "@/axios/apiService";
import { ref } from "vue";
import swal from "sweetalert";

const tanggal = ref("");
const data = ref("");
const errorLog = ref("");
const loading = ref(false);

const apiService = new ApiService();

const openModal = () => {
  document.getElementById("modalLoading")?.classList.add("d-block", "show");
  document.body.insertAdjacentHTML("beforeend", '<div class="modal-backdrop fade show" id="backdrop"></div>');
};

const closeModal = async () => {
  loading.value = false;
  document.getElementById("modalLoading")?.classList.remove("d-block", "show");
  document.getElementById("backdrop")?.remove();
  await new Promise((r) => setTimeout(r, 100));
};

const startLoading = () => {
  loading.value = true;
  openModal();
};

const getPostel = async (tanggal) => {
  if (!tanggal) {
    swal({
      icon: "warning",
      text: "Tanggal harus diisi terlebih dahulu",
    });
    return;
  }
  try {
    startLoading();
    const res = await apiService.getPostel(tanggal);
    const { dataCount, dbCount } = res.data || {};
    errorLog.value = `[SUCCESS] Penyalinan data berhasil\n\nInfo:\n${JSON.stringify(res.data, null, 2)}`;
    await closeModal();

    await swal({
      icon: "success",
      title: "Penyalinan Data Berhasil!",
      text: `Total ${dbCount} dari ${dataCount} data berhasil disalin`,
    });
  } catch (error) {
    await closeModal();
    const resData = error.response?.data;
    const errorMsg = resData?.responseErrorFile || resData?.message;
    errorLog.value = `[ERROR] ${errorMsg}`;

    await swal({
      icon: "error",
      title: "Penyalinan Data Gagal",
      text: errorMsg,
    });
  }
};

const getPostelPy = async (tanggal) => {
  if (!tanggal) {
    swal({
      icon: "warning",
      text: "Tanggal harus diisi terlebih dahulu",
    });
    return;
  }
  try {
    startLoading();
    const res = await apiService.getPostelPy(tanggal);
    const info = typeof res.data === 'string' ? res.data : JSON.stringify(res.data, null, 2);
    errorLog.value = `[SUCCESS] Penarikan data dari Kominfo berhasil.\n\nInfo:\n${info}`;
    await closeModal();

    await swal({
      icon: "success",
      title: "Penarikan Data Selesai",
      text: 'File berhasil ditarik. Silahkan lanjut dengan klik "Run Node Parser".',
    });
  } catch (error) {
    await closeModal();
    const resData = error.response?.data;
    const errorMsg = resData?.responseErrorFile || resData?.message;
    errorLog.value = `[ERROR] ${errorMsg}`;

    await swal({
      icon: "error",
      title: "Penarikan Data Gagal",
      text: errorMsg,
    });
  }
};

</script>

<style>
.swal-footer {
  text-align: center;
}
</style>
